import { Box, Button, styled, Tabs, Tab, Checkbox } from '@mui/material';
import pallet from '../../../layouts/pallet';

export const PageContainer = styled(Box)(() => ({}));

export const HeaderBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: '24px'
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: '10px 20px'
}));

export const StyledTabs = styled(Tabs)(() => ({
  marginBottom: '24px',
  '& .MuiTabs-indicator': {
    backgroundColor: pallet.primary,
    height: 3,
    borderRadius: 2
  }
}));

export const StyledTab = styled(Tab)(() => ({
  textTransform: 'none',
  color: pallet.formLabelText,
  padding: '8px 20px',
  fontSize: '15px',
  '&.Mui-selected': {
    color: pallet.primary,
    fontWeight: 600
  }
}));

export const StyledCheckbox = styled(Checkbox)<{
  isNewAdmissionStudent?: boolean;
}>(({ isNewAdmissionStudent }) => ({
  borderRadius: '4px !important',
  color: `${
    isNewAdmissionStudent ? pallet.formLabelText : pallet.disabledGrey
  } !important`,
  '& .MuiFormControlLabel-label': {
    color: `${
      isNewAdmissionStudent ? pallet.formLabelText : pallet.disabledGrey
    } !important`
  },
  '& .Mui-checked': {
    color: `${
      isNewAdmissionStudent ? pallet.formLabelText : pallet.disabledGrey
    } !important`
  },
  '& .MuiCheckbox-indeterminate': {
    color: `${pallet.formLabelText} !important`
  }
}));
